import { render, staticRenderFns } from "./all-orders.vue?vue&type=template&id=23b9b7f6&scoped=true"
import script from "./all-orders.vue?vue&type=script&lang=js"
export * from "./all-orders.vue?vue&type=script&lang=js"
import style0 from "./all-orders.vue?vue&type=style&index=0&id=23b9b7f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b9b7f6",
  null
  
)

export default component.exports